module.exports = __webpack_public_path__ + "static/img/zt3-pic1.6afa290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/zt3-pic1.jpg
// module id = YZH1
// module chunks = 171